import { IReactionDisposer, onBecomeObserved, onBecomeUnobserved, reaction } from 'mobx';

export function subscribeUniversal<K>(
  store: any,
  field: K | K[],
  onSubscribe: () => void,
  onUnsubscribe: () => void,
  isAuthorizedCallback?: () => boolean | undefined
) {
  let observedFieldsNumber = 0;
  let disposer: IReactionDisposer | undefined;
  let isSubscriptionActive = false;

  const fields = Array.isArray(field) ? field : [field];

  const internalSubscribe = () => {
    if (!isSubscriptionActive) {
      onSubscribe();
      isSubscriptionActive = true;
    }
  };

  const internalUnsubscribe = () => {
    if (isSubscriptionActive) {
      onUnsubscribe();
      isSubscriptionActive = false;
    }
  };

  function processFields() {
    if (observedFieldsNumber > 0 && (!isAuthorizedCallback || isAuthorizedCallback() === true)) {
      internalSubscribe();
    } else if (observedFieldsNumber === 0 || (isAuthorizedCallback && !isAuthorizedCallback())) {
      internalUnsubscribe();
    }
  }

  fields.forEach(f => {
    onBecomeObserved(store, f, () => {
      observedFieldsNumber += 1;
      processFields();
    });
    onBecomeUnobserved(store, f, () => {
      observedFieldsNumber -= 1;
      processFields();
    });
  });

  if (isAuthorizedCallback) {
    disposer = reaction(isAuthorizedCallback, processFields);
  }

  return (
    disposer ||
    (() => {
      // empty
    })
  );
}
